import React from 'react';

interface DialogCardCandidateInfoProps {
    name: string;
    email: string;
}

function DialogCardCandidateInfo({ name, email }: DialogCardCandidateInfoProps): React.JSX.Element {
    return (
        <div className="flex flex-col">
            <h3 className="text-foreground text-3xl font-bold">{name}</h3>
            <p className="text-foreground text-sm font-normal break-all">{email}</p>
        </div>
    );
}

export default DialogCardCandidateInfo;
